import { render } from "./AffableChair.vue?vue&type=template&id=a1634d50"
import script from "./AffableChair.vue?vue&type=script&lang=js"
export * from "./AffableChair.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__